import * as React from 'react';

import * as style from './CallField.css';

export const CallField: React.FC<React.PropsWithChildren<{}>> = props => {
  const { children } = props;

  return <div className={style['field']}>{children}</div>;
};
